import react, { useEffect, useState } from "react";
import { addScriptFile, loggerStore, removeScriptFile } from "./utils";
import { useNavigate } from "react-router";
import configData from "../Config";
import { apis } from "../services/apiService";

const IngenicoPaymentGateway = () => {
  let currentDate = new Date();
  const navigate = useNavigate();
  let consumerCodeVar = "";
  let screenType = "";
  let mobileNo;
  let pfScreenData = {}; //PF screen location data

  const navigateOnSuccessHandler = async (res, navigationState) => {
    try {
      let reqData = res;
      reqData.id = res?.merchantTransactionIdentifier;
      reqData.CustomerId = consumerCodeVar;
      const baseUrlForPayStatus =
        navigationState.screenType === "RP"
          ? configData.RepaymentUrl
          : configData.API_URL;
      let resp = await apis.postApi(
        // configData.RepaymentUrl + "PluralPayment/IngenicoPaymentStatus",
        // baseUrlForPayStatus + "PluralPayment/IngenicoPaymentStatus",
        baseUrlForPayStatus +
          `${
            navigationState.screenType === "RP"
              ? "PaymentController" // for old API use PluralPaymentController
              : "PaymentMethod"
          }/IngenicoPaymentStatus`,
        reqData
      );

      let result = await resp.json();
      if (resp?.status === 200) {
        let updatedNavigation = { ...navigationState };
        if (navigationState.screenType === "RP") {
          //it is for repayment screen
          delete updatedNavigation.screenType;
          navigate("/PaymentSuccess", {
            state: { ...updatedNavigation },
          });
        } else if (navigationState.screenType === "PF") {
          //it is for PF payment screen
          delete updatedNavigation.screenType;
          updatedNavigation.Status = true;
          updatedNavigation.AppId = consumerCodeVar;
          updatedNavigation.IsLimitEnhacement_Reduction_PFSucess =
            pfScreenData?.IsLimitEnhacement_Reduction_PF;
          navigate("/PFPaymentSuccess", {
            state: { ...updatedNavigation },
          });
        }
        loggerStore(
          res?.merchantTransactionIdentifier,
          `Ingenico Payment IngenicoPaymentStatus api call success for ${screenType} = ${JSON?.stringify(
            res
          )}`,
          "information"
        );
      }
      // .then((response) => response.json())
      // .then((res) => {
      //   let updatedNavigation = { ...navigationState };
      //   if (navigationState.screenType === "RP") {
      //     //it is for repayment screen
      //     delete updatedNavigation.screenType;
      //     navigate("/PaymentSuccess", {
      //       state: { ...updatedNavigation },
      //     });
      //   } else if (navigationState.screenType === "PF") {
      //     //it is for PF payment screen
      //     delete updatedNavigation.screenType;
      //     updatedNavigation.Status = true;
      //     updatedNavigation.AppId = consumerCodeVar;
      //     navigate("/PFPaymentSuccess", {
      //       state: { ...updatedNavigation },
      //     });
      //   }
      //   loggerStore(
      //     res?.merchantTransactionIdentifier,
      //     `Ingenico Payment IngenicoPaymentStatus api call success for ${screenType} = ${JSON?.stringify(
      //       res
      //     )}`,
      //     "information"
      //   );
      // })
      // .catch((err) => {
      //   let errorMsg = JSON?.parse(err?.message);
      //   loggerStore(
      //     res?.merchantTransactionIdentifier,
      //     `Ingenico Payment IngenicoPaymentStatus api call error for ${screenType} = ${JSON?.stringify(
      //       errorMsg
      //     )}`,
      //     "error"
      //   );
      // });
    } catch (error) {
      let errorMsg = JSON?.parse(error?.message);
      loggerStore(
        res?.merchantTransactionIdentifier,
        `Ingenico Payment IngenicoPaymentStatus api call error for ${screenType} = ${JSON?.stringify(
          errorMsg
        )}`,
        "error"
      );
    }
  };

  function handleResponse(res) {
    if (
      typeof res != "undefined" &&
      typeof res.paymentMethod != "undefined" &&
      typeof res.paymentMethod.paymentTransaction != "undefined" &&
      typeof res.paymentMethod.paymentTransaction.statusCode != "undefined" &&
      res.paymentMethod.paymentTransaction.statusCode == "0300"
    ) {
      // success block
      let navigationState = {
        //it is for repayment screen
        referenceno: res?.merchantTransactionIdentifier,
        amount: res.paymentMethod.paymentTransaction.amount,
        paidamount: res.paymentMethod.paymentTransaction.amount,
        mn: mobileNo,
        paymentstatus: "Paid",
        screenType: screenType,
      };
      navigateOnSuccessHandler(res, navigationState);
      loggerStore(
        res?.merchantTransactionIdentifier,
        `Ingenico Payment success response for ${screenType} = ${JSON?.stringify(
          res
        )}`,
        "Information"
      );
    } else if (
      typeof res != "undefined" &&
      typeof res.paymentMethod != "undefined" &&
      typeof res.paymentMethod.paymentTransaction != "undefined" &&
      typeof res.paymentMethod.paymentTransaction.statusCode != "undefined" &&
      res.paymentMethod.paymentTransaction.statusCode == "0398"
    ) {
      // initiated block

      loggerStore(
        res?.merchantTransactionIdentifier,
        `Ingenico Payment itiated response for ${screenType} = ${JSON?.stringify(
          res
        )}`,
        "Information"
      );
    } else {
      // error block
      if (screenType === "RP") {
        navigate("/repaymentLMS", {
          state: {
            mn: mobileNo,
            err: "Transaction is failed kindly retry again",
          },
        });
      }
      if (screenType === "PF") {
        navigate("/pfpayment", {
          state: {
            ...pfScreenData,
            err: "Transaction is failed kindly retry again",
          },
        });
      }

      loggerStore(
        res?.merchantTransactionIdentifier,
        `Ingenico Payment  error response for ${screenType} = ${JSON?.stringify(
          res
        )}`,
        "error"
      );
      let errorMsg =
        res?.stringResponse?.split("|")?.[2] || "We are facing some issue";
      alert(errorMsg);
    }
  }

  const openIngenicoPayScreen = (enachReqData) => {
    // console.log("enachReqData-----", enachReqData);
    let reqJson = {
      features: {
        enableAbortResponse: true,
        enableExpressPay: true,
        enableInstrumentDeRegistration: true,
        enableMerTxnDetails: true,
        enableNewWindowFlow: true, //for hybrid applications please disable this by passing false
      },
      consumerData: {
        deviceId: enachReqData?.deviceId, //possible values "WEBSH1" or "WEBSH2"
        token: enachReqData?.token,
        // returnUrl: enachReqData?.requestURL,
        returnUrl:
          enachReqData?.type === "RP"
            ? navigate("/repaymentLMS")
            : navigate("/pfpayment"),
        responseHandler: handleResponse,
        paymentMode: enachReqData?.payableMode,
        merchantLogoUrl: "/assets/logoTygerCapital.svg", //provided merchant logo will be displayed
        merchantId: enachReqData?.merchantId,
        currency: enachReqData?.currency,
        consumerId: enachReqData?.consumerId, //Your unique consumer identifier to register a eMandate/eNACH
        consumerMobileNo: enachReqData?.consumerMobileNo,
        // consumerEmailId: enachReqData?.consumerEmailId,
        txnId: enachReqData?.txnId, //Unique merchant transaction ID
        items: [enachReqData?.items],
        customStyle: {
          PRIMARY_COLOR_CODE: "#45beaa", //merchant primary color code
          SECONDARY_COLOR_CODE: "#FFFFFF", //provide merchant's suitable color code
          BUTTON_COLOR_CODE_1: "#2d8c8c", //merchant's button background color code
          BUTTON_COLOR_CODE_2: "#FFFFFF", //provide merchant's suitable color code for button text
        },
      },
    };
    consumerCodeVar = enachReqData?.consumerId;
    screenType = enachReqData?.type;
    mobileNo = enachReqData?.consumerMobileNo;
    if (enachReqData?.type === "PF") {
      pfScreenData = enachReqData?.pfScreenData;
    }
    loggerStore(
      enachReqData?.consumerId,
      `Ingenico Payment request for ${screenType} = ${JSON.stringify(reqJson)}`,
      "Information"
    );
    window?.$?.pnCheckout(reqJson);
    if (reqJson?.features?.enableNewWindowFlow) {
      window?.$?.pnCheckoutShared?.openNewWindow();
      loggerStore(
        enachReqData?.consumerId,
        `Ingenico Payment modal opened for ${screenType} = ${JSON.stringify(
          reqJson
        )}`,
        "Information"
      );
    }
  };

  return { openIngenicoPayScreen };
};

export default IngenicoPaymentGateway;
